import React, { Fragment, useContext } from 'react';
import EnvCtx from "../../contexts/EnvCtx";
const Footer = () => {
    const { logoCamera } = useContext(EnvCtx);

    return (
        <Fragment>
            <footer className="container-fluid bg-dark text-center text-white footer" style={{backgroundColor: "rgba(0, 0, 0, 0.2)"}}>

                <div className="container p-3" >
                    <div className="row align-items-center">
                        {logoCamera ? (
                            <img src={logoCamera} style={{maxWidth:'300px'}} alt="camera di commercio" className="logo-image img-fluid" loading="lazy" />
                        ) : (
                            <img src={require('../../assets/images/BO.png')} style={{maxWidth:'300px'}} alt="default camera di commercio" className="logo-image img-fluid" loading="lazy" />
                        )}
                        <p className="text-end col-6 d-none d-md-block">
                            <span>È un servizio realizzato da</span>
                            <a className="text-white text-end" href="https://www.infocamere.it/" target={"_blank"} rel="noreferrer">
                                <img src={require(`../../assets/images/footerLogoDX.png`)} alt="InfoCamere" className="logo-image img-fluid" loading="lazy" />
                            </a>
                        </p>
                    </div>
                    <div className="row">
                        <hr/>
                        <div className="col-lg-2 col-md-2">
                            <i>Privacy Policy e Note legali</i>
                        </div>
                        <div className="col-lg-10 col-md-10">
                            <p >InfoCamere SCpa - sede legale: Via G.B. Morgagni, 13 - 00161 Roma -
                                P.IVA/C.F. 02313821007 - Codice LEI 815600EAD78C57FCE690</p>
                        </div>
                    </div>
                </div>
            </footer>
        </Fragment>
    );
};

export default Footer;